import React, { ReactNode } from 'react';

import BackdropLoader from '@/components/BackdropLoader';
import ErrorAccessDenied from '@/components/ErrorAccessDenied/ErrorAccessDenied';

interface CorePermissionGuardProps {
  children: ReactNode;
  hasPermission?: boolean;
  isLoading?: boolean;
  showAccessDenied?: boolean;
}

const CorePermissionGuard: React.FC<CorePermissionGuardProps> = ({
  children,
  hasPermission,
  isLoading,
  showAccessDenied
}) => {
  if (isLoading) {
    return showAccessDenied ? <BackdropLoader /> : null;
  }

  if (!hasPermission) {
    return showAccessDenied ? <ErrorAccessDenied /> : null;
  }

  return <>{children}</>;
};

export default CorePermissionGuard;
